import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface UserDataState {
  user_name: string;
  name: string;
  access_token: string;
}

const initialState: UserDataState = {
  user_name: '',
  name: '',
  access_token: '',
};

const userDataSlice = createSlice({
  name: 'userData',
  initialState,
  reducers: {
    setUserData: (state, action: PayloadAction<UserDataState>) => {
      state.user_name = action.payload.user_name;
      state.name = action.payload.name;
      state.access_token = action.payload.access_token;
    },
    setLogoutState: () => initialState,
  },
});

export const { setUserData, setLogoutState } = userDataSlice.actions;
export default userDataSlice.reducer;
